import PropTypes from 'prop-types';
// @mui
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
//
import EmptyContent from '../empty-content';

export default function TableNoData({ notFound, sx, colSpan = 100 }) {
  if (!notFound) {
    return null;
  }

  return (
    <TableRow>
      <TableCell colSpan={colSpan} sx={{ p: 0, border: 'none' }}>
        <EmptyContent
          filled
          title="No Data"
          sx={{
            py: 10,
            width: 1,
            maxWidth: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            ...sx,
          }}
        />
      </TableCell>
    </TableRow>
  );
}

TableNoData.propTypes = {
  notFound: PropTypes.bool,
  sx: PropTypes.object,
  colSpan: PropTypes.number,
};
